import { Component } from "react";

class Title extends Component {
  constructor(props) {
    super(props);
    this.state = {  }
    this.title = this.title.bind(this);
  }

  title() {
    switch (this.props.variant) {
      case '2':
        return <h2 className="uppercase font-t-semibold text-4xl" >{this.props.title}</h2> 
      case '3':
        return <h3 className="uppercase font-t-semibold text-xl" >{this.props.title}</h3> 
      default:
        return <h3 className="uppercase font-t-semibold text-xl" >{this.props.title}</h3> 
    }
  }

  render() { 
    let subtitleClasses = `text-${this.props.justify}`;
    switch (this.props.variant) {
      case 'big':
        subtitleClasses += ' text-2xl font-t-regular ';
        break;
      case '2': 
        subtitleClasses += ' text-2xl font-t-regular ';
      break;
      default:
        subtitleClasses += ' text-xl my-4 font-t-semibold ';
        break;
    }
    return (
      <div className={`flex flex-col items-${this.props.justify}`}>
        <this.title />
        <hr className="border border-orange w-20 my-4" />
        {this.props.subtitle ? <p className={subtitleClasses}>{this.props.subtitle}</p> : ''}
      </div>
    );
  }
}
 
export default Title;